import { InjectionToken } from '@angular/core';
import { HttpResponse, HttpRequest, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuth2Status } from './OAuth2Service';

export interface ITokenStore {
	userInfo: string;
	tokenUpdated(responseText: HttpResponse<string>): void;
	statusChanged(status: OAuth2Status): void;
	setupRequest(request: HttpRequest<any>): HttpRequest<any>;
	refreshRequest(client: HttpClient): Observable<HttpResponse<string>>;
	logout(): void;
}

export const TokenStore = new InjectionToken<ITokenStore>('Token store');



// WEBPACK FOOTER //
// ./src/app/angular-rest/ITokenStore.ts